import { IDealResolution, Sizing } from 'utils/camera-photo/media-services';

export const getCameraAccess = () => navigator.mediaDevices.getUserMedia({ video: {
  width: {
    ideal: idealResolution.width.ideal,
  }
} });

export const idealWidthResolution: Sizing = {
  min: 1280,
  ideal: 2048,
  max: 2048
};

export const idealHeightResolution: Sizing = {
  min: 960,
  ideal: 1536, // Preserve 4:3 aspect ratio (2048 * 3/4 = 1536)
  max: 1536,
};

export const idealResolution: IDealResolution = {
  width: idealWidthResolution,
};

export const lowResolution: IDealResolution = {
  width: {
    min: 1280,
    max: 1600,
  },
  height: {
    min: 960,
    max: 1200,
  }
};
